import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {filterList, Menu, MenuService, sortBySortOrder, SubscriberComponent} from 'brewbill-lib';

@Component({
    selector: 'bb-manage-modifiers',
    templateUrl: './manage-modifiers.component.html',
    styleUrls: ['./manage-modifiers.component.scss'],
})
export class ManageModifiersComponent extends SubscriberComponent implements OnInit {
    @Input() selectedModifiers: any[];
    @Output() selectedModifiersChange = new EventEmitter<any[]>();

    @Input() ignoreGroups = false;
    @Input() buildModifierItem: (item: any, sortOrder: number) => any;
    @Output() addMenuModifier = new EventEmitter<any>();
    @Output() addMenuModifierSelection = new EventEmitter<any>();
    @Output() addMenuModifierGroup = new EventEmitter<any>();

    menu: Menu;
    selectModifierType = false;
    modifierOptions: any[] = [];

    constructor(private menuService: MenuService) {
        super();
    }

    ngOnInit() {
        this.menu = this.menuService.currentValue;
        this.setModifierOptions();

        this.subscribe(this.menuService.current.subscribe(m => {
            this.menu = !!m ? new Menu(m) : null;
            this.setModifierOptions();
        }));
    }

    removeModifier(item: any) {
        const temp = this.selectedModifiers.filter(m =>
            (!!item.menuModifierSelection && (!m.menuModifierSelection || item.menuModifierSelection.id !== m.menuModifierSelection.id))
            || (!!item.menuModifierGroup && (!m.menuModifierGroup || item.menuModifierGroup.id !== m.menuModifierGroup.id))
            || (!!item.menuModifier && (!m.menuModifier || item.menuModifier.id !== m.menuModifier.id))
        );

        this.selectedModifiersChange.emit(sortBySortOrder(temp));
    }

    markModifiers(items: any[], selectedItems: any[], selectionParam: string, disabledParam: string) {
        items.forEach(i => {
            if (!!i.options) {
                i[selectionParam] = selectedItems.some(s => !!s.menuModifierSelection && s.menuModifierSelection.id === i.id);
            } else if (!!i.selections) {
                i[selectionParam] = selectedItems.some(s => !!s.menuModifierGroup && s.menuModifierGroup.id === i.id);
            } else {
                i[selectionParam] = selectedItems.some(s => !!s.menuModifier && s.menuModifier.id === i.id);
            }
        });
    }

    updateSelectedModifiers(modifiers: any[]) {
        const update = this.selectedModifiers.filter(m => {
            if (!!m.menuModifierSelection) {
                return modifiers.some(i => !!i.options && i.id === m.menuModifierSelection.id);
            } else if (!!m.menuModifierGroup) {
                return modifiers.some(i => !!i.selections && i.id === m.menuModifierGroup.id);
            } else {
                return modifiers.some(i => !i.options && !i.selections && (i.id === m.menuModifier.id));
            }
        });

        modifiers.filter(i => {
            if (!!i.options) {
                return !update.some(m => !!m.menuModifierSelection && m.menuModifierSelection.id === i.id);
            } else if (!!i.selections) {
                return !update.some(m => !!m.menuModifierGroup && m.menuModifierGroup.id === i.id);
            } else {
                return !update.some(m => !!m.menuModifier && m.menuModifier.id === i.id);
            }
        }).forEach(mod => {
            update.push(this.buildModifierItem(mod, update.length));
        });

        this.selectedModifiersChange.emit(sortBySortOrder(update));
    }

    setModifierOptions() {
        if (!!this.menu) {
            this.modifierOptions = this.ignoreGroups ?
                [...this.menu.menuModifiers, ...this.menu.menuModifierSelections] :
                [...this.menu.menuModifiers, ...this.menu.menuModifierSelections, ...this.menu.menuModifierGroups];

            this.modifierOptions.sort((a, b) => {
                const textA = a.name.toLowerCase();
                const textB = b.name.toLowerCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
        } else {
            this.modifierOptions = [];
        }
    }

    filterByName(items: any[], filter: string) {
        return filterList(items, filter, 'name');
    }

    sortModifiersAlphabetical() {
        let list = [...this.selectedModifiers];
        if (!!list && list.length > 1) {
            list = list.sort((a, b) => {
                let aName = '';
                if (!!a.menuModifier && !!a.menuModifier.name) {
                    aName = a.menuModifier.name;
                } else if (!!a.menuModifierSelection && !!a.menuModifierSelection.name) {
                    aName = a.menuModifierSelection.name;
                } else if (!!a.menuModifierGroup && !!a.menuModifierGroup.name) {
                    aName = a.menuModifierGroup.name;
                }

                let bName = '';
                if (!!b.menuModifier && !!b.menuModifier.name) {
                    bName = b.menuModifier.name;
                } else if (!!b.menuModifierSelection && !!b.menuModifierSelection.name) {
                    bName = b.menuModifierSelection.name;
                } else if (!!b.menuModifierGroup && !!b.menuModifierGroup.name) {
                    bName = b.menuModifierGroup.name;
                }

                return aName.localeCompare(bName.toLowerCase());
            });
            let sortIndex = 0;
            list.forEach(s => s.sortOrder = sortIndex++);
            this.selectedModifiers = list;
        }
    }

    openAddMenuModifier() {
        this.selectModifierType = false;
        this.addMenuModifier.emit();
    }

    openAddMenuModifierSelection() {
        this.selectModifierType = false;
        this.addMenuModifierSelection.emit();
    }

    openAddMenuModifierGroup() {
        this.selectModifierType = false;
        this.addMenuModifierGroup.emit();
    }
}
